import { render, staticRenderFns } from "./dataPermissions.vue?vue&type=template&id=6d4ad60a"
import script from "./dataPermissions.vue?vue&type=script&lang=js"
export * from "./dataPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports